<template>
<div>
  <v-layout v-if="inicialicePage" row  v-resize="onResize"  fill-height >
    <v-flex xs12 >
      <v-card :style="heightWindowStyle">
        <v-toolbar dense style="margin-bottom: 0px; height: auto">
          <v-toolbar-title @click="$router.push('/home')">
            <v-avatar class="mr-2"
              :size="30"
              color="grey lighten-4"
            >
              <img src="/img/logo1.png">
            </v-avatar>
            <span class="body-2">
              GIS Mundo Sano
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <p class="pt-2 body-2 " :style="help.styles[1]" v-if="confActives.coords">{{ currentData.variableName }}</p>
          <v-divider vertical style="margin:0px 4px 0px 4px"></v-divider>
          <p class="pt-2 body-2 " :style="help.styles[2]" v-if="confActives.coords">{{ currentData.date }}</p>
          <v-divider vertical style="margin:0px 4px 0px 4px"></v-divider>
          <p class="pt-2 body-2 " :style="help.styles[3]" v-if="confActives.coords">{{ previewCenter }}</p>
          <v-toolbar-items >
            <v-btn @click="activeDialog('search')" :style="help.styles[4]" text fab small >
              <v-icon size="18">fas fa-search</v-icon>
            </v-btn>
            <v-btn v-if="settings.navigate" :style="help.styles[5]" @click="activeDialog('add')" text fab small>
              <v-icon size="18">fas fa-layer-group</v-icon>
            </v-btn>
            <v-btn v-if="settings.navigate" :style="help.styles[6]" text @click="activeDialog('conf')" fab small>
              <v-icon size="18">fas fa-cogs</v-icon>
            </v-btn>
            <v-menu
              v-model="help.menu"
              :close-on-content-click="false"
              :close-on-click="false"
              :nudge-width="200"
              offset-x
            >
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" fab small>
                  <v-icon size="18">fas fa-question-circle</v-icon>
                </v-btn>
              </template>

              <v-card id="help_card_menu" >
                <v-card-title primary-title>
                  Ayuda 
                  <v-spacer></v-spacer>
                  <v-icon size="20">fas fa-question</v-icon>
                </v-card-title>
                <v-card-text>
                  <p v-html="help.text[help.currentStep]">
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn small text @click="cancelHelp()">Cancelar</v-btn>
                  <v-btn small color="primary" v-if="help.currentStep != this.help.limit" text @click="nextHelp">Siguiente</v-btn>
                  <v-btn small color="primary" v-if="help.currentStep == this.help.limit" text @click="cancelHelp()">Terminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-toolbar-items>
          <template v-slot:extension v-if="loading" >
            <v-progress-linear :active="loading" :indeterminate="loading"  color="primary"></v-progress-linear>
          </template>
        </v-toolbar>
        <v-layout
          wrap  
          justify-space-between
          pa-1 fill-height
        >
          <v-flex md3  v-if="settings.toolbar" >
            <v-card :style="heightWindowStyle">
              <v-card-text :style="'max-height:' + (heightWindow / 1.3) + 'px; overflow-y: auto'">
                <v-layout row wrap>
                  <v-flex xs12 :style="help.styles[7]">
                    <v-card-actions>
                      Capas
                      <v-spacer></v-spacer>
                      <v-btn @click="collapse.layers = !collapse.layers" text fab small>
                        <v-icon>fas fa-angle-down {{ collapse.layers ? '' : 'fa-rotate-90' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <div class="ml-4 pl-1">
                      <v-icon 
                        @click="getData(defaultLayer)"
                        v-text="'fas fa-globe'"
                        class="v-icon notranslate v-treeview-node__toggle v-icon--link"
                        size="15"
                      ></v-icon>
                      <span class="v-treeview-node__label">Indice de Ovoposicion final</span>
                    </div>
                    <v-treeview v-if="collapse.layers" class="ml-4" :items="items"  activatable>
                      <template v-slot:prepend="props">
                        <v-icon 
                          v-if="props.item.type != 'father'"
                          @click="getData(props.item)"
                          v-text="'fas fa-globe'"
                          size="15"
                        ></v-icon>
                      </template>
                    </v-treeview>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 v-if="confActives.references" :style="help.styles[8]" id="references">
                    <v-card-actions>
                      Referencias
                      <v-spacer></v-spacer>
                      <v-btn @click="collapse.references = !collapse.references" text fab small>
                        <v-icon>fas fa-angle-down {{ collapse.references ? '' : 'fa-rotate-90' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-list v-if="collapse.references">
                      <v-list-item avatar v-for="(value, key) in references" :key="key">
                        <v-list-item-avatar>
                          <div :style="'height: 10px; width:10px; background-color: ' + value.color"></div>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{ value.value }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 v-if="confActives.stadistic" :style="help.styles[9]" id="stadistics">
                    <v-card-actions>
                      Estadisticas
                      <v-spacer></v-spacer>
                      <v-btn @click="collapse.stadistic = !collapse.stadistic" text fab small>
                        <v-icon>fas fa-angle-down {{ collapse.stadistic ? '' : 'fa-rotate-90' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-list v-if="collapse.stadistic">
                      <v-list-item avatar v-for="(value, key) in stadistic" :key="key">
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong>
                              {{ value.label }}
                            </strong>
                          </v-list-item-title>    
                          <v-list-item-title>{{ value.value }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex 
            :md9="settings.toolbar"
            :md12="!settings.toolbar"
            d-flex
            text-xs-center
          >
             <l-map 
              :key="mapKey"
              v-if="mapActive" 
              id="map"
              :style="heightWindowStyle" 
              :zoom.sync="zoom" 
              :options="mapOptions"  
              :center="center"  
              :min-zoom="minZoom" 
              :max-zoom="maxZoom" 
              @update:center="centerUpdated"
              >
              <l-control-sum position="topleft"></l-control-sum>
                <l-control-layers 
                :position="layersPosition"/>
                <l-tile-layer 
                  v-for="(tileProvider, index) in tileProviders" 
                  :key="index"
                  layerType="base" 
                  :name="tileProvider.name" 
                  :visible="tileProvider.visible" 
                  :url="tileProvider.url" 
                  :attribution="tileProvider.attribution" 
                  :token="token" 
                  :id="tileProvider"/>
                <l-tilelayer-googlemutant 
                  v-if="false"
                  name="Google Satelite"
                  lang="es" :options="{type: 'satellite'}">
                </l-tilelayer-googlemutant>
                
                <l-marker-cluster 
                  v-if="layerActives.clusterActive"
                  :options="clusterOptions">
                  <l-marker  
                    v-for="marker in points" 
                    :key="marker.id" 
                    :visible="true" 
                    :draggable="false" 
                    :lat-lng="[marker.lat, marker.lng]" 
                    >
                      <l-popup :content="marker.modal" />
                      <l-tooltip :content="marker.tooltip" />
                  </l-marker>
                </l-marker-cluster>
                <l-circle 
                  v-for="point in points"
                  :key="point.lat"
                  v-if="point.geometry == 'POINT'"
                  :lat-lng="[point.lat,point.lng]"
                  :radius="2000"
                  :color="point.color"
                  @click="activeDialog('point', point)"
                />
                <l-polygon 
                  :key="point.lat"
                  v-for="point in points"
                  v-if="point.geometry == 'POLYGON'"
                  :lat-lngs="point.geo"
                  :color="point.color"
                  @click="activeDialog('point', point)"
                />
              </l-map>
          </v-flex>
          <v-flex pl-3 pr-3 xs12 v-if="confActives.line" >
            <v-card>
              <v-subheader>
                {{dates[0]}}
                <v-spacer></v-spacer>
                 {{dates[52]}}
              </v-subheader>              
              <v-card-text class="pt-0">
                
                <v-slider 
                  :style="help.styles[11]"
                  @change="getByDate" 
                  color="indigo"
                  v-model="inputDate" 
                  step="1" 
                  hide-details
                  ticks="always"
                  tick-size="2"
                  :value="[0,1]"
                  thumb-label
                  :thumb-size="64"
                  :max="52"
                >
                  <template v-slot:thumb-label="{value}">
                    <v-chips>{{dates[value]}} </v-chips>
                  </template>
                </v-slider>
              </v-card-text>
            </v-card>            
            
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog
      v-model="dialog.active"
      scrollable  
      
      :max-width="dialog.width"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs6 text-left>
              <h3 v-if="dialog.type == 'conf'">Configuración del mapa</h3>
              <h3 v-if="dialog.type == 'add'">Agregar Capa</h3>
              <h3 v-if="dialog.type == 'search'">Buscar Punto</h3>
              <div v-if="dialog.type == 'point'">
                <h3>  
                  {{ dialog.data.tooltip }}
                  <br>
                  <small>{{ dialog.data.title }} | {{ dialog.data.subtitle }}</small>
                </h3>
              </div>
            </v-flex>
            <v-flex text-right>
              <v-btn @click="dialog.active = false" color="error" fab small text >
                <v-icon style="top: 0; right: 0; position: relative;">
                  fas fa-times
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <div v-if="dialog.type == 'conf'">
            <v-subheader>Intervalos</v-subheader>
            <v-select
              :items="[{text: 'Cuantiles', value: 'cuantil'}, {text: 'Intervalos Iguales', value: 'intervals_equals'}, {text: 'Media de ciudades modelo', value: 'model'} ]"
              v-model="confActives.cuantil"
              label="Rango de colores"
            ></v-select>
            <v-subheader>Personalizar vista</v-subheader>
            <v-layout row wrap>
              <v-flex xs6>
                <v-switch
                  color="green lighten-2" 
                  :label="(confActives.coords ? 'Ocultar' : 'Mostrar' )+ ' Coordenadas'" 
                  v-model="confActives.coords"/>
                <v-switch
                  color="green lighten-2" 
                  :label="(confActives.line ? 'Ocultar' : 'Mostrar') + ' Linea de tiempo'" 
                  v-model="confActives.line"
                  @change="resizeMap()" />
              </v-flex>
              <v-flex xs6>
                <v-switch
                  color="green lighten-2" 
                  :label="(confActives.references ? 'Ocultar' : 'Mostrar') + ' Referencias'" 
                  v-model="confActives.references"/>
                <v-switch
                  color="green lighten-2" 
                  :label="(confActives.stadistic ? 'Ocultar' : 'Mostrar') + ' Estadisticas'" 
                  v-model="confActives.stadistic" />
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-subheader>Centrar Mapa</v-subheader>
            <v-layout row wrap>
              <v-flex xs5 mr-2>
                <v-text-field
                  name="lat"
                  label="Latitud"
                  id="lat"
                  v-model="confActives.center.lat"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 mr-2>
                <v-text-field
                  name="lat"
                  label="Longitud"
                  id="lat"
                  v-model="confActives.center.lng"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn fab small text @click="setCenter(confActives.center)"><v-icon>fas fa-map-pin</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dialog.type == 'add'">
            <v-list>
              <v-list-item avatar :key="key" v-for="(layer, key) in dialog.data">
                <v-list-item-avatar>
                  <v-btn @click="addLayer(layer)" :color="layer.active ? 'error' : 'success'" fab text small>
                    <v-icon>{{ layer.active ? 'fas fa-minus' : 'fas fa-plus' }}</v-icon>
                  </v-btn>
                </v-list-item-avatar>
                <v-list-item-title>{{ layer.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
          <div v-if="dialog.type == 'search'">
            <v-card>
              <v-card-text>
                <v-text-field
                  name="search"
                  label="Buscar"
                  id="search"
                  v-model="toolbarSearch.text"
                  prepend-icon="fas fa-search"
                ></v-text-field>

                <v-data-table
                  :headers="[{text: 'Localidades', value: 'tooltip'}, {text: 'Provincia', value: 'title'}, {text: 'Categoria/Departamento', value: 'subtitle'}, {text: 'Acciones', value: 'actions' }]"
                  :items="points"
                  class="elevation-1"
                  pagination.sync="pagination"
                  item-key="id"
                  :search="toolbarSearch.text"
                >
                  
                  <template v-slot:item.actions="props">
                    <td>
                      <v-btn small fab text @click="activeDialog('point', props.item)"><v-icon>fa fa-eye</v-icon></v-btn>
                      <v-btn small fab text @click="setCenter(props.item)"><v-icon>fa fa-globe-americas</v-icon></v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </div>
          <div v-if="dialog.type == 'point'">
            <v-layout row wrap>
              <v-flex xs6>
                <span class="subtitle">
                  <strong>Lat:</strong> {{ dialog.data.lat }}
                </span>
              </v-flex>
              <v-flex xs6>
                <span class="subtitle">
                  <strong>Long:</strong> {{ dialog.data.lng }}
                </span>
              </v-flex>
              <v-flex xs6>
                <span class="subtitle">
                  <strong>Value:</strong> {{ dialog.data.value }}
                </span>
              </v-flex>
              <v-flex xs12 >
                <v-layout row wrap>
                  <v-flex xs3 text-center :key="key" v-for="(ned, key) in dialog.data.ned">
                    <strong>{{ned.name}}: </strong>{{ned.value}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                Evolución del ultimo año, {{ dialog.data.initDate }} - {{ dialog.data.endDate }}
                <line-chart :chart-data="lineChartData" :options="chartOptions" :key="chartKey"></line-chart>            
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="dialog.active = false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  <v-layout align-center v-else row  v-resize="onResize"  fill-height justify-center>
    <v-flex xs6 class="text-center">
      <v-card flat  :style="heightWindowCharge">
        <v-card-text>
          <img src="/img/favicon.png" class="rotate" width="100" height="100" />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
  <v-snackbar
  :color="alert.color"
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.message }}
	 	  <v-btn text  @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
</div>
</template>
<script>
  
  export default {
    created(){
      this.validData();
    },
    mounted(){
      this.onResize();
      this.index();
    },
    data() {
      return {
        inicialicePage: false,
        heightWindowCharge: '',
        toolwind: 0,
        toolbarSearch: {
          active: false,
          text: ''
        },
        loading: false,
        lineChartData: {
          labels: [],
          datasets: []
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false
        },
        chartKey: 0,
        items: [],
        dialog: {
          active: false,
          type: '',
          data: {},
          width: '500px',
        },
        maxZoomHeat: 10,
        minOpacity: 0.75,
        configDialog: false,
        baseRoute: process.env.VUE_APP_URL + 'api/gis',
        filters: {
          id_variable: '',
          date: '',
          rangeColors: false,
        },
        layerActives: {
          heatActive: false,
          clusterActive: false,
          circlesActive: true,
        },
        points: [],
        center: [-36.879621, -53.700538],
        init: 0,
        mapActive: false,
        radius: 0,
        blur: 0,
        token: 'pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
        zoom:4,
        tileProviders: [
          {
            name: 'Carreteras',
            visible: false,
            id:'',
            key: 1,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: 'Mundo sano',
          },
          {
            name: 'Satelital sin delimitación',
            visible: false,
            id:'',
            key: 2,
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            attribution: 'Mundo sano',
          },
          {
            name: 'Satelital con delimitación',
            id: 'mapbox.satellite',
            visible: true,
            key: 3,
            accessToken: 'pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
            attribution: 'Mundo sano',
          },
        ],
        clusterOptions: {},
        zoomPosition: 'topleft',
        mapOptions: { zoomControl: false , attributionControl: false },
        attributionPosition: 'bottomright',
        layersPosition: 'topright',
        attributionPrefix: 'Vue2Leaflet',    
        maxZoom:150,
        minZoom: 0,
        heatPoints: [],
        markers: [],
        settings: {
          toolbar: true,
          navigate: true,
        },
        heightWindowStyle: '10000px',
        heightWindow: '',
        previewCenter: 'LatLng(-36.879621, -53.700538)',
        confActives: {
          cuantil: 'model',
          coords: true,
          line: true,
          references: true,
          stadistic: true,
          center: {
            lat: '',
            lng: '',
            color: ''
          },
        },
        collapse: {
          layers: true,
          references: true,
          stadistic: true
        },
        inputDate: 0,
        dates: [],
        currentData: {
          date: '',
          variable: {}
        },
        mapKey: 0,
        references: [],
        stadistic: [],
        pointsSearch: [],
        currentVar: '',
        defaultLayer: {
          date: '',
          id: 103,
          type: 'calculate'
        },
        help:{
          menu: false,
          styles: ['','','','','','',''],
          limit: 11,
          text: [
            '¡Bienvenido/a!, que tal si damos un recorrido por algunos elementos de la herramienta',
            'Aqui veras el nombre de la variable que tienes actualmente activa, por defecto el mapa carga el indice de Ovoposicion estimado que es un indicativo que predice si las condiciones ambientales en una semana son favorables para que el mosquito se reproduzca',
            'Esta es la fecha en formato YYYY-MM-DD de los datos que estan activos en el mapa, la mayoria de los datos que componen la plataforma son semanales, por la fecha activa habarca los datos de lunes a domingo de esa semana',
            'Para guiarte mejor, cada vez que te muevas por el mapa aqui apareceran las coordenadas del centro de donde te encuentras',
            'Si tienes problemas para encontrar una localidad en especifico puedes buscarla y geoposicionarla desde aquí',
            'Desde aqui podras agregar capas de datos adicionales que puedes consultar en el mapa, no olvides revisar el catalago de variables ambientales y datos geoposicionados <a class="indigo--text" href="/help/index" target="_blank">catalago de variables ambientales y datos geoposicionados</a> para mas información',
            'Desde aqui puedes ocultar algunos elementos del mapa, como las coordenadas, las  Estadisticas, la linea de tiempo, etc',
            'Las Capas son el conjunto de variables y datos que puedes viisualizar en el mapa',
            'Las referencias indican el intervalo del valor por color de cada conjunto de datos',
            'Las Estadisticas, te muestran los datos estadisticos de la busqueda actual',
            'Si pulsas sobre un punto del mapa tendras informacion adicional, como la curva del dato historico y el valor exacto de la variable activa en ese punto',
            'Esta es la linea del tiempo, cada punto representa una semana, al mover al circulo podras navegar por los datos historicos del ultimo año de la variable que tienes activa',
            'Para obtener información adicional y leer la documentacion completa no olvides visitar el <a href="/help/index" target="_blank"> Manual de usuario </a>'
          ],
          currentStep: 0,
        },
        alert: {
          active: false,
          message: '',
          color: ''
        }
      }
    },
    computed: {
      
    },

    watch: {
      '$store.state.api.logged': function(){
        if(!this.$store.state.api.logged){
          this.confActives.references = true;
          this.confActives.line = false;
          this.baseRoute = process.env.VUE_APP_URL + 'api/gis/map/nonlogin'
          this.settings.toolbar = false;
          this.settings.navigate = false;
          this.help.limit = 4
          this.getData(this.defaultLayer);
          this.onResize();
        }else{
          this.help.limit = 11
          this.baseRoute = process.env.VUE_APP_URL + 'api/gis/map'
          this.settings.toolbar = true;
          this.settings.navigate = true;
          this.mapKey = 1;
          this.onResize();

        }
      },
      'help.menu': function(){
        if(!this.help.menu){
          this.cancelHelp();
        }
      }
    },

    methods: {
      
      validData(){
        var formData;
        this.inicialicePage = false;
        if(!this.$store.state.api.logged){
          this.help.limit = 4
          this.confActives.references = false;
          this.confActives.line = false;
          formData = {
            'id_variable': 103,
            'date': this.currentData.date,
            'type': 'calculate',
            'cuantil': this.confActives.cuantil
          }
          this.settings.toolbar = false;
          this.settings.navigate = false;
          this.baseRoute = process.env.VUE_APP_URL + 'api/gis/map/nonlogin'
        }else{
          this.help.limit = 11
          this.baseRoute = process.env.VUE_APP_URL + 'api/gis/map'
          formData = {
            'id_variable': 103,
            'date': this.currentData.date,
            'type': 'calculate',
            'cuantil': this.confActives.cuantil
          }
        }
        this.currentData.variable = this.defaultLayer;
        axios.post(this.baseRoute + '/getData', formData).then((res) => { 
          this.points = res.data.points.mapData;
          this.dates = res.data.datesAvalible;
          this.currentData.variableName = res.data.variable;
          this.currentData.date = res.data.dateQuery;
          this.stadistic = res.data.points.stadistic;
          this.references = res.data.points.references;
          this.collapse.references = !this.collapse.references;
          if(this.dates[this.inputDate] != this.currentData.date){
            this.inputDate = this.dates.length - 1; 
          }
          this.inicialicePage = true;
          this.mapKey = 1;
        }).catch((error) => {
            this.inicialicePage = true;
            this.alert = {
              active: true,
              message: 'Hubó un error inesperado',
              color: 'Warning'
            }
        });
      },
      index(){
        let formData = {
          layer: 'calculate'
        };
        this.loading = true;
        this.$nextTick(() =>{
          axios.post(this.baseRoute + '/getLayer', formData).then((res) => {
            this.items = res.data;
            this.mapActive = true;
            this.$nextTick(() => {
              this.loading = false;
            })
          }).catch((error) => {
            this.loading = false;
            this.alert = {
                active: true,
                message: 'Hubó un error inesperado',
                color: 'Warning'
              }

          });
        })
      },
      addLayer(layer){
        if(layer.type == 'localSistem'){
          let valid  = this.items.findIndex((item) => {
            return item.id == layer.name
          })
          if(valid == -1){
            layer.active = true
            this.getLayer(layer.name)
          }else{
            layer.active = false
            this.items.splice(valid, 1);
          }
        }
      },
      getLayer(layer){
        let formData = {
          'layer': layer
        };
        this.loading = true;
        this.$nextTick(() =>{
          axios.post(this.baseRoute + '/getLayer', formData).then((res) => {
            this.loading = false;
            this.items.push(res.data[0]);
            this.mapKey = 1;
          }).catch((error) => {
            this.loading = false;
          });
        })
      },
      onResize(){
        if(this.settings.toolbar){
          this.heightWindowStyle = 'height: ' + (window.innerHeight - 155) + 'px; width:100%;';
          this.heightWindow = window.innerHeight;  
        }else{
          this.heightWindowStyle = 'height: ' + (window.innerHeight ) + 'px; width:100%;';
          this.heightWindow = window.innerHeight;  
        }
        this.heightWindowCharge = 'height: ' + (window.innerHeight ) + 'px; width:100%; background: transparent; justify-content: center; align-items: center; display: flex;';
      },
      resizeMap(){
        if(this.confActives.line){
          this.heightWindowStyle = 'height: ' + (window.innerHeight - 155) + 'px; width:100%;';
          this.heightWindow = window.innerHeight;

        }else{
          this.heightWindowStyle = 'height: ' + (window.innerHeight - 40) + 'px; width: 100%;';
          this.heightWindow = window.innerHeight;
        }
      },
      activeDialog(type, data = {}){
        if(type == 'conf'){
          this.dialog.active = true;
          this.dialog.type = type;
          this.dialog.width = '500px';
        }else if(type == 'add'){
          this.loading = true;
          this.$nextTick(() =>{
            axios.get(this.baseRoute + '/getHabilitedLayers').then((res) => {
              this.loading = false;
              this.dialog.data = res.data;
              this.dialog.active = true;
              this.dialog.type = type;
              this.dialog.width = '500px';
            }).catch((error) => {
              this.loading = false;
            });
          })
        }else if(type == 'search'){
          this.dialog.data = data;
          this.dialog.active = true;
          this.dialog.type = type;
          this.dialog.width = '800px';
        }else if(type == 'point'){
          this.dialog.data = data;
          this.dialog.type = type;
          this.dialog.active = true;
          let currentDate = new Date(this.currentData.date);
          let initDate = new Date((currentDate.getFullYear() - 1), currentDate.getMonth(), currentDate.getDate())
          let initDateString = initDate.getFullYear() + '-' + initDate.getMonth().toString().padStart(2,'0') + '-' + initDate.getDate().toString().padStart(2,'0');
          let filters = {
            dateInit: initDateString,
            dateEnd: this.currentData.date,
            id_variable: this.currentData.variable.id,
            id_point: data.id_point,
            type: false,
          }
          this.dialog.data.initDate = initDateString;
          this.dialog.data.endDate = this.currentData.date;
          this.dialog.width = '800px';
          this.loading = true;
          this.$nextTick(() =>{
            axios.put(this.baseRoute + '/getGraphicsData', filters).then((res) => {
              this.loading = false;
              this.dialog.data.ned = res.data.ned
              this.lineChartData = {
                labels: res.data.labels,
                datasets: [
                  {
                    label: res.data.label,
                    backgroundColor: 'transparent',
                    borderColor:'#' + Math.floor(Math.random()*16777215).toString(16),
                    data: res.data.dataset
                  }
                ]
              }
            }).catch((error) =>  {
              this.loading = false;
            });
          })

        }
      },
      centerUpdated(center){
        this.previewCenter = center; 
      },
      getData(variable){
        if(this.loading == false){ 
          this.currentData.variable = variable;
          let formData = {
            'id_variable': variable.id,
            'date': this.currentData.date,
            'type': variable.type,
            'cuantil': this.confActives.cuantil
          }
          this.loading = true;    
          this.collapse.references = !this.collapse.references;
          axios.post(this.baseRoute + '/getData', formData).then((res) => {
            this.points = res.data.points.mapData;
            this.dates = res.data.datesAvalible;
            this.currentData.variableName = res.data.variable;
            this.currentData.date = res.data.dateQuery;
            this.stadistic = res.data.points.stadistic;
            this.references = res.data.points.references;
            this.collapse.references = !this.collapse.references;
            if(this.dates[this.inputDate] != this.currentData.date){
              this.inputDate = this.dates.length - 1; 
            }
            this.loading = false;    
            this.mapKey = 1;

          }).catch((error) => {
            this.alert.active = true;
            this.alert.message = 'hubó un error inesperado durante la ejecución';
            this.alert.color = "warning"
            this.loading = false;    
          });
        }
      },
      getByDate(){
        this.currentData.date = this.dates[this.inputDate];
        this.getData(this.currentData.variable);
      },
      getValueDate(value){
        return this.dates[value];
      },
      setCenter(item){
        this.dialog.active = false;
        this.dialog.data = {}
        this.zoom = 12
        setTimeout(() => {
          this.center = [item.lat, item.lng]
        }, 300)
        let originalColor = item.color
        let colors = [
          '#FFFF00',
          '#00FF00'
        ];
        let i = 0
        let interval = setInterval(() => {
            i++
            if(i == colors.length){
              i = 0
            }
            item.color = colors[i]
        }, 400)
        setTimeout(() => {
          clearInterval(interval)
          item.color = originalColor
        },7000)
      },
      nextHelp(){
        this.help.currentStep++;
        if(this.help.currentStep == 10){
          let point = {"dateInit":"2019-03-26","dateEnd":"2020-04-27","id_variable":103,"id_point":1,"type":false}
          this.activeDialog('point', point);
        }else if(this.help.currentStep == 11){
          this.dialog.active = false;
          this.confActives.line = true;
        }
        if(this.help.currentStep > this.help.limit){
          console.log("HOLA=")
          this.help.currentStep = this.help.text.length - 1;
          for (var i = this.help.styles.length - 1; i >= 0; i--) {
            this.help.styles[i] = ''
          }
        }else{
          for (var i = this.help.styles.length - 1; i >= 0; i--) {
            this.help.styles[i] = ''
          }
          this.help.styles[this.help.currentStep] = 'border: solid 1px green; border-radius: 10px; padding: 4px'
        }
      },
      cancelHelp(){
        this.help.menu = false;
        this.help.currentStep = 0;
        this.dialog.active = false;
        for (var i = this.help.styles.length - 1; i >= 0; i--) {
            this.help.styles[i] = ''
          }
      }

    }
  }
</script>
<style>
  #core-view{
    padding-bottom: 0px !important;
  }
  .v-overlay{
    z-index: 1100 !important;
  }
  .v-dialog__content{
    z-index: 1101 !important;
  }
  .v-menu__content{
    z-index: 1102 !important;
    top: 70px !important;
  }
  .v-treeview-node__label{
    font-size: 0.8em !important;
  }
  .v-toolbar__extension{
    height: 5px !important;
    padding: 0px !important;
  }
  .v-toolbar__content{
    margin-left: 0px !important;
  }
  .v-card{
    margin: 0px !important;
  }
  .rotate {
    animation: rotation 3s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
</style>